import BackgroundColor from "%/dynamic-component-editor/options/background-color";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Plan sheet segmented control: the selected segment's fill.
export default class SelectedBackgroundColor extends BackgroundColor {
  static userInterfaceComponent = {
    label: "Selected Background",
    component: inspectorTools.COLOR_PICKER,
    props: {
      width: "fill",
      displayAsSelectInput: true,
      colorContext: "Backgrounds",
    },
  };

  static defaultValue = {
    value: "pure",
    source: "theme.background",
  };
}
